import axios from 'axios';
import { hostUI } from '../../configuraciones';
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

// =========================================================================
// 1. THUNK: OBTENER REGISTROS DE GRANEL DE ENVASADO POR ID_LOGIN
// Endpoint: GET /api/v1/bitacora-envasado/granel/:id_login
// =========================================================================
export const obtenerGranelesEnvasadoPorLogin = createAsyncThunk(
    'bitacoraEnvasado/obtenerGraneles',
    async (paramsOrId, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const isObject = typeof paramsOrId === 'object' && paramsOrId !== null;
            const idLogin = (isObject ? paramsOrId.id_login : paramsOrId) ||
                state?.Usuario?.data?.user?.[0]?.id ||
                state?.Usuario?.user?.[0]?.id ||
                state?.Usuario?.data?.idlogin ||
                state?.Usuario?.data?.id ||
                null;

            if (!idLogin) {
                return { total: 0, page: 1, limit: 10, totalPages: 1, data: [] };
            }

            const queryParams = isObject ? { ...paramsOrId } : {};
            delete queryParams.id_login;

            const fullUrl = hostUI + `bitacora-envasado/granel/${idLogin}`;
            const res = await axios.get(fullUrl, { params: queryParams });
            return res.data;
        } catch (error) {
            console.error('Error al obtener graneles de envasado:', error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// =========================================================================
// 2. THUNK: REGISTRAR LOTE A GRANEL DIRECTO (ENVASADO)
// Endpoint: POST /api/v1/bitacora-envasado/granel
// =========================================================================
export const registrarGranelEnvasado = createAsyncThunk(
    'bitacoraEnvasado/registrarGranel',
    async (granelData, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const idLogin = granelData.id_login ||
                granelData.idLogin ||
                state?.Usuario?.data?.user?.[0]?.id ||
                state?.Usuario?.user?.[0]?.id ||
                state?.Usuario?.data?.idlogin ||
                state?.Usuario?.data?.id ||
                null;

            const payload = {
                id_login: idLogin,
                ...granelData,
            };

            const fullUrl = hostUI + 'bitacora-envasado/granel';
            const res = await axios.post(fullUrl, payload);
            return res.data?.data || res.data;
        } catch (error) {
            console.error('Error al registrar granel envasado:', error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// =========================================================================
// 3. THUNK: IMPORTAR LOTE DESDE PRODUCCIÓN A ENVASADO (BORRADOR)
// Endpoint: POST /api/v1/bitacora-envasado/granel/desde-produccion
// =========================================================================
export const importarGranelDesdeProduccion = createAsyncThunk(
    'bitacoraEnvasado/importarDesdeProduccion',
    async (importData, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const idLogin = importData.id_login ||
                importData.idLogin ||
                state?.Usuario?.data?.user?.[0]?.id ||
                state?.Usuario?.user?.[0]?.id ||
                null;

            const payload = {
                id_login: idLogin,
                ...importData
            };

            const fullUrl = hostUI + 'bitacora-envasado/granel/desde-produccion';
            const res = await axios.post(fullUrl, payload);
            return res.data?.data || res.data;
        } catch (error) {
            console.error('Error al importar granel desde producción:', error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// =========================================================================
// 4. THUNK: REGISTRAR FUSIÓN / MEZCLA DE GRANELES (ENVASADO)
// Endpoint: POST /api/v1/bitacora-envasado/granel/fusion
// =========================================================================
export const registrarFusionGranelEnvasado = createAsyncThunk(
    'bitacoraEnvasado/registrarFusion',
    async (fusionData, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const idLogin = fusionData.id_login ||
                fusionData.idLogin ||
                state?.Usuario?.data?.user?.[0]?.id ||
                state?.Usuario?.user?.[0]?.id ||
                null;

            const payload = {
                id_login: idLogin,
                ...fusionData,
            };

            const fullUrl = hostUI + 'bitacora-envasado/granel/fusion';
            const res = await axios.post(fullUrl, payload);
            return res.data?.data || res.data;
        } catch (error) {
            console.error('Error al registrar fusión envasado:', error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// =========================================================================
// 5. THUNK: DESHACER MOVIMIENTO DE GRANEL (BORRADOR)
// Endpoint: POST /api/v1/bitacora-envasado/granel/deshacer/:id
// =========================================================================
export const deshacerMovimientoGranelEnvasado = createAsyncThunk(
    'bitacoraEnvasado/deshacerMovimiento',
    async (id, { rejectWithValue }) => {
        try {
            const fullUrl = hostUI + `bitacora-envasado/granel/deshacer/${id}`;
            const res = await axios.post(fullUrl);
            return { id, data: res.data };
        } catch (error) {
            console.error('Error al deshacer movimiento envasado:', error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// =========================================================================
// 6. THUNK: ACTUALIZAR GRANEL (ENVASADO)
// Endpoint: PUT /api/v1/bitacora-envasado/granel/:id
// =========================================================================
export const actualizarGranelEnvasado = createAsyncThunk(
    'bitacoraEnvasado/actualizarGranel',
    async ({ id, granelData }, { rejectWithValue }) => {
        try {
            const fullUrl = hostUI + `bitacora-envasado/granel/${id}`;
            const res = await axios.put(fullUrl, granelData);
            return res.data?.data || res.data;
        } catch (error) {
            console.error('Error al actualizar granel envasado:', error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// =========================================================================
// 7. THUNK: REGISTRAR TRASLADO ENTRE INSTALACIONES (ENVASADO)
// Endpoint: POST /api/v1/bitacora-envasado/granel/traslado
// =========================================================================
export const registrarTrasladoGranelEnvasado = createAsyncThunk(
    'bitacoraEnvasado/registrarTraslado',
    async (trasladoData, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const idLogin = trasladoData.id_login ||
                trasladoData.idLogin ||
                state?.Usuario?.data?.user?.[0]?.id ||
                state?.Usuario?.user?.[0]?.id ||
                null;

            const payload = {
                id_login: idLogin,
                ...trasladoData,
            };

            const fullUrl = hostUI + 'bitacora-envasado/granel/traslado';
            const res = await axios.post(fullUrl, payload);
            return res.data?.data || res.data;
        } catch (error) {
            console.error('Error al registrar traslado envasado:', error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// =========================================================================
// 8. THUNK: REGISTRAR DILUCIÓN / AJUSTE DE GRADO ALCOHÓLICO (ENVASADO)
// Endpoint: POST /api/v1/bitacora-envasado/granel/dilucion
// =========================================================================
export const registrarDilucionGranelEnvasado = createAsyncThunk(
    'bitacoraEnvasado/registrarDilucion',
    async (dilucionData, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const idLogin = dilucionData.id_login ||
                dilucionData.idLogin ||
                state?.Usuario?.data?.user?.[0]?.id ||
                state?.Usuario?.user?.[0]?.id ||
                null;

            const payload = {
                id_login: idLogin,
                ...dilucionData,
            };

            const fullUrl = hostUI + 'bitacora-envasado/granel/dilucion';
            const res = await axios.post(fullUrl, payload);
            return res.data?.data || res.data;
        } catch (error) {
            console.error('Error al registrar dilución envasado:', error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// =========================================================================
// 9. THUNK: REGISTRAR SALIDA / BAJA DE PRODUCTO (ENVASADO)
// Endpoint: POST /api/v1/bitacora-envasado/granel/baja
// =========================================================================
export const registrarBajaGranelEnvasado = createAsyncThunk(
    'bitacoraEnvasado/registrarBaja',
    async (bajaData, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const idLogin = bajaData.id_login ||
                bajaData.idLogin ||
                state?.Usuario?.data?.user?.[0]?.id ||
                state?.Usuario?.user?.[0]?.id ||
                null;

            const payload = {
                id_login: idLogin,
                ...bajaData,
            };

            const fullUrl = hostUI + 'bitacora-envasado/granel/baja';
            const res = await axios.post(fullUrl, payload);
            return res.data?.data || res.data;
        } catch (error) {
            console.error('Error al registrar baja envasado:', error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// =========================================================================
// 10. THUNK: REGISTRAR SALIDA A MUESTREO (ENVASADO)
// Endpoint: POST /api/v1/bitacora-envasado/granel/muestreo
// =========================================================================
export const registrarMuestreoGranelEnvasado = createAsyncThunk(
    'bitacoraEnvasado/registrarMuestreo',
    async (muestreoData, { getState, rejectWithValue }) => {
        try {
            const state = getState();
            const idLogin = muestreoData.id_login ||
                muestreoData.idLogin ||
                state?.Usuario?.data?.user?.[0]?.id ||
                state?.Usuario?.user?.[0]?.id ||
                null;

            const payload = {
                id_login: idLogin,
                ...muestreoData,
            };

            const fullUrl = hostUI + 'bitacora-envasado/granel/muestreo';
            const res = await axios.post(fullUrl, payload);
            return res.data?.data || res.data;
        } catch (error) {
            console.error('Error al registrar muestreo envasado:', error);
            return rejectWithValue(error.response?.data?.message || error.message);
        }
    }
);

// =========================================================================
// SLICE & REDUCER
// =========================================================================
const initialState = {
    granelRecords: [],
    granelPagination: {
        total: 0,
        page: 1,
        limit: 10,
        totalPages: 1
    },
    loadingGranel: false,
    errorGranel: null,
    loading: false,
    error: null,
    successMessage: null
};

const bitacoraEnvasadoSlice = createSlice({
    name: 'bitacoraEnvasado',
    initialState,
    reducers: {
        limpiarErrores: (state) => {
            state.error = null;
            state.errorGranel = null;
            state.successMessage = null;
        },
        setGranelRecords: (state, action) => {
            state.granelRecords = action.payload;
        }
    },
    extraReducers: (builder) => {
        // --- Obtener Graneles ---
        builder.addCase(obtenerGranelesEnvasadoPorLogin.pending, (state) => {
            state.loadingGranel = true;
            state.errorGranel = null;
        });
        builder.addCase(obtenerGranelesEnvasadoPorLogin.fulfilled, (state, action) => {
            state.loadingGranel = false;
            const payload = action.payload;
            if (payload && typeof payload === 'object' && Array.isArray(payload.data)) {
                state.granelRecords = payload.data;
                state.granelPagination = {
                    total: payload.total ?? payload.data.length,
                    page: payload.page || 1,
                    limit: payload.limit || 10,
                    totalPages: payload.totalPages || 1
                };
            } else if (payload && typeof payload === 'object' && Array.isArray(payload.records)) {
                state.granelRecords = payload.records;
                state.granelPagination = {
                    total: payload.total ?? payload.records.length,
                    page: payload.page || 1,
                    limit: payload.limit || 10,
                    totalPages: payload.totalPages || 1
                };
            } else {
                const arr = Array.isArray(payload) ? payload : (payload?.data || payload?.graneles || []);
                state.granelRecords = arr;
                state.granelPagination = {
                    total: arr.length,
                    page: 1,
                    limit: arr.length || 10,
                    totalPages: 1
                };
            }
        });
        builder.addCase(obtenerGranelesEnvasadoPorLogin.rejected, (state, action) => {
            state.loadingGranel = false;
            state.errorGranel = action.payload || action.error?.message;
        });

        // --- Registrar Granel ---
        builder.addCase(registrarGranelEnvasado.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(registrarGranelEnvasado.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload) {
                state.granelRecords.unshift(action.payload);
            }
            state.successMessage = "Lote de granel de envasado registrado exitosamente";
        });
        builder.addCase(registrarGranelEnvasado.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error?.message;
        });

        // --- Importar desde Producción ---
        builder.addCase(importarGranelDesdeProduccion.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(importarGranelDesdeProduccion.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload) {
                state.granelRecords.unshift(action.payload);
            }
            state.successMessage = "Granel importado desde producción en borrador exitosamente";
        });
        builder.addCase(importarGranelDesdeProduccion.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error?.message;
        });

        // --- Registrar Fusión ---
        builder.addCase(registrarFusionGranelEnvasado.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(registrarFusionGranelEnvasado.fulfilled, (state, action) => {
            state.loading = false;
            if (action.payload) {
                state.granelRecords.unshift(action.payload);
            }
            state.successMessage = "Fusión de granel de envasado registrada exitosamente";
        });
        builder.addCase(registrarFusionGranelEnvasado.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error?.message;
        });

        // --- Deshacer Movimiento ---
        builder.addCase(deshacerMovimientoGranelEnvasado.fulfilled, (state, action) => {
            state.loading = false;
            const id = action.payload?.id;
            if (id) {
                state.granelRecords = state.granelRecords.filter(r =>
                    r.id_bitacora_granel !== id && r.id !== id && r.noLote !== id
                );
            }
            state.successMessage = "Movimiento en borrador deshecho y volumen reintegrado con éxito";
        });

        // --- Actualizar Granel ---
        builder.addCase(actualizarGranelEnvasado.fulfilled, (state, action) => {
            state.loading = false;
            const updated = action.payload;
            if (updated) {
                const idx = state.granelRecords.findIndex(r =>
                    (r.id_bitacora_granel && r.id_bitacora_granel === updated.id_bitacora_granel) ||
                    (r.id && r.id === updated.id)
                );
                if (idx >= 0) {
                    state.granelRecords[idx] = { ...state.granelRecords[idx], ...updated };
                }
            }
        });

        // --- Registrar Traslado ---
        builder.addCase(registrarTrasladoGranelEnvasado.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(registrarTrasladoGranelEnvasado.fulfilled, (state, action) => {
            state.loading = false;
            const updated = action.payload;
            if (updated) {
                const targetId = updated.id || updated.id_bitacora_granel || updated.dbId;
                const idx = state.granelRecords.findIndex(r =>
                    (targetId && (r.id === targetId || r.id_bitacora_granel === targetId || r.dbId === targetId))
                );
                if (idx >= 0) {
                    state.granelRecords[idx] = { ...state.granelRecords[idx], ...updated };
                }
            }
            state.successMessage = "Traslado registrado exitosamente";
        });
        builder.addCase(registrarTrasladoGranelEnvasado.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error?.message;
        });

        // --- Registrar Dilución ---
        builder.addCase(registrarDilucionGranelEnvasado.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(registrarDilucionGranelEnvasado.fulfilled, (state, action) => {
            state.loading = false;
            const updated = action.payload;
            if (updated) {
                const targetId = updated.id || updated.id_bitacora_granel || updated.dbId;
                const idx = state.granelRecords.findIndex(r =>
                    (targetId && (r.id === targetId || r.id_bitacora_granel === targetId || r.dbId === targetId))
                );
                if (idx >= 0) {
                    state.granelRecords[idx] = { ...state.granelRecords[idx], ...updated };
                }
            }
            state.successMessage = "Dilución registrada exitosamente";
        });
        builder.addCase(registrarDilucionGranelEnvasado.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error?.message;
        });

        // --- Registrar Baja ---
        builder.addCase(registrarBajaGranelEnvasado.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(registrarBajaGranelEnvasado.fulfilled, (state, action) => {
            state.loading = false;
            const updated = action.payload;
            if (updated) {
                const targetId = updated.id || updated.id_bitacora_granel || updated.dbId;
                const idx = state.granelRecords.findIndex(r =>
                    (targetId && (r.id === targetId || r.id_bitacora_granel === targetId || r.dbId === targetId))
                );
                if (idx >= 0) {
                    state.granelRecords[idx] = { ...state.granelRecords[idx], ...updated };
                }
            }
            state.successMessage = "Baja de granel registrada exitosamente";
        });
        builder.addCase(registrarBajaGranelEnvasado.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error?.message;
        });

        // --- Registrar Muestreo ---
        builder.addCase(registrarMuestreoGranelEnvasado.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        builder.addCase(registrarMuestreoGranelEnvasado.fulfilled, (state, action) => {
            state.loading = false;
            const updated = action.payload;
            if (updated) {
                const targetId = updated.id || updated.id_bitacora_granel || updated.dbId;
                const idx = state.granelRecords.findIndex(r =>
                    (targetId && (r.id === targetId || r.id_bitacora_granel === targetId || r.dbId === targetId))
                );
                if (idx >= 0) {
                    state.granelRecords[idx] = { ...state.granelRecords[idx], ...updated };
                }
            }
            state.successMessage = "Muestreo de granel registrado exitosamente";
        });
        builder.addCase(registrarMuestreoGranelEnvasado.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload || action.error?.message;
        });
    }
});

export const { limpiarErrores, setGranelRecords } = bitacoraEnvasadoSlice.actions;
export default bitacoraEnvasadoSlice.reducer;
